import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const setDeviceInfoActions = createDataModuleActions('SET_DEVICE_INFO');

export const setDeviceInfo = setDeviceInfoActions.dataRequest;
export const setDeviceInfoSuccess = setDeviceInfoActions.dataSuccess;
export const setDeviceInfoError = setDeviceInfoActions.dataError;
export const setDeviceInfoReset = setDeviceInfoActions.dataReset;
